import { TagDto } from '@maia/tags';
import { BrokerDto, CustomerDto, IQuotationEntity } from '../shared';
import { undefinedOrTransformToDTOCurried } from '@maia/utils';
import { QuotationProductDto } from './quotation-product.dto';

export class QuotationDto {
  readonly guid: string;
  readonly reference: string;
  readonly status: ReturnType<typeof TagDto.getQuotationTag>;
  readonly products: Array<QuotationProductDto>;
  readonly price: number;
  readonly customer: CustomerDto;
  readonly createdAt: Date;
  readonly createdBy: BrokerDto;

  constructor(entity: IQuotationEntity) {
    this.guid = entity.guid;
    this.reference = entity.reference.toString();
    this.status = TagDto.getQuotationTag(entity.status);
    this.createdAt = new Date(entity.created_at);
    this.products = [];
    this.products = entity.products.map(
      (product) => new QuotationProductDto(product),
    );
    this.price = entity.price;
    this.customer = new CustomerDto(entity.customer);
    this.createdBy = new BrokerDto(entity.created_by);
  }
}

export const undefinedOrQuotation = undefinedOrTransformToDTOCurried(
  (entity: IQuotationEntity) => new QuotationDto(entity),
);
